export const isFormCompleted = (values, errors) => {
  const hasValues = Object.values(values).every(value => value !== '');
  const hasErrors = Object.keys(errors).length > 0;
  return hasValues && !hasErrors;
};
